import React, { Component } from 'react'
import { connect } from 'react-redux'
import { initializeConfiguration } from '../actions/app'
import { DispatchThunk } from '../actions/types'
import LoadingOverlay from '../components/LoadingOverlay'
import { positionRelativeBounding, wrapper } from './App.css'
import UploadOptions from './UploadOptions'
import { WtaiUploadWidgetProps } from '../types'
import { StoreState } from '../reducer/types'

interface StateProps {
  uploading: boolean
}

interface DispatchProps {
  initializeConfiguration: () => void
}

type ComponentProps = Pick<
  WtaiUploadWidgetProps,
  'headingText' | 'subheadingText' | 'site' | 'initFreshToken' | 'pasteOnly' | 'alignText'
>

export type AppProps = StateProps & DispatchProps & ComponentProps

export class App extends Component<AppProps> {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.props.initializeConfiguration()
    }
  }

  render() {
    const { uploading, headingText, subheadingText, pasteOnly, alignText } = this.props
    return (
      <div className={positionRelativeBounding}>
        <div className={wrapper}>
          <LoadingOverlay uploading={uploading}>
            <UploadOptions
              headingText={headingText}
              subheadingText={subheadingText}
              pasteOnly={pasteOnly}
              alignText={alignText}
            />
          </LoadingOverlay>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: StoreState): StateProps => ({
  uploading: state.upload.uploading,
})

const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  initializeConfiguration: () => dispatch(initializeConfiguration),
})

export default connect<StateProps, DispatchProps>(
  // @ts-ignore
  mapStateToProps,
  mapDispatchToProps
)(App)
